<template>
  <div
    class="modal fade"
    id="bannerModal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <button
            type="button"
            class="btn-close"
            @click="closeBanner"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body pt-0">
          <div v-if="banner" class="text-center">
            <div v-if="banner.image" class="mb-4">
              <img
                :src="banner.image"
                :alt="banner.title"
                class="img-fluid rounded"
                style="max-height: 500px; width: 100%; object-fit: cover;"
              />
            </div>
            <h3 class="mb-3">{{ banner.title }}</h3>
            <p class="text-gray-600 mb-4">{{ banner.content }}</p>
            <div v-if="banner.btn_text && banner.btn_action" class="d-flex flex-column flex-sm-row justify-content-center gap-2">
              <button
                type="button"
                class="btn btn-light"
                @click="closeBanner"
              >
                Fechar
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="handleBannerClick"
              >
                {{ banner.btn_text }}
              </button>
            </div>
            <div v-else class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-primary"
                @click="closeBanner"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../helpers/http";

export default {
  name: "BannerModal",
  data() {
    return {
      banner: null,
      modalInstance: null,
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
    place() {
      return this.$store.state.auth.place;
    },
  },
  watch: {
    place: {
      handler(newPlace) {
        if (newPlace && this.userAuth) {
          // Aguarda um pequeno delay para garantir que o place está totalmente carregado
          setTimeout(() => {
            this.loadBanner();
          }, 500);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    const modalElement = document.getElementById("bannerModal");
    this.modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement, {
      backdrop: "static", // Não fecha ao clicar fora
      keyboard: false, // Não fecha com ESC
    });

    // Previne fechamento ao clicar no backdrop
    modalElement.addEventListener("click", (e) => {
      if (e.target === modalElement) {
        e.stopPropagation();
      }
    });

    // Configura o backdrop escuro quando o modal é exibido
    modalElement.addEventListener("shown.bs.modal", () => {
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
        backdrop.style.opacity = "1";
        // Previne fechamento ao clicar no backdrop
        backdrop.style.pointerEvents = "none";
      }
    });

    // Restaura pointer events quando o modal é escondido
    modalElement.addEventListener("hidden.bs.modal", () => {
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.style.pointerEvents = "";
      }
    });
  },
  methods: {
    async loadBanner() {
      if (!this.userAuth?.id_user) {
        return;
      }

      try {
        const response = await http.get(
          `/users/${this.userAuth.id_user}/banners`
        );

        if (response.data && response.data.id_banner) {
          this.banner = response.data;
          this.showBanner();
        }
      } catch (error) {
        // Banner não encontrado ou erro na requisição - não exibe nada
        console.debug("Nenhum banner disponível:", error);
      }
    },
    showBanner() {
      if (this.modalInstance && this.banner) {
        this.modalInstance.show();
        // Garante que o backdrop fique escuro após mostrar
        this.$nextTick(() => {
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) {
            backdrop.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
            backdrop.style.opacity = "1";
          }
        });
      }
    },
    async closeBanner() {
      if (this.banner && this.banner.id_banner) {
        try {
          await http.patch(
            `/users/${this.userAuth.id_user}/banners/${this.banner.id_banner}/read`
          );
        } catch (error) {
          console.error("Erro ao marcar banner como lido:", error);
        }
      }

      if (this.modalInstance) {
        this.modalInstance.hide();
      }

      this.banner = null;
    },
    async handleBannerClick() {
      if (this.banner && this.banner.id_banner) {
        try {
          await http.patch(
            `/users/${this.userAuth.id_user}/banners/${this.banner.id_banner}/click`
          );
        } catch (error) {
          console.error("Erro ao registrar clique no banner:", error);
        }
      }

      // Processa a ação do botão
      if (this.banner.btn_action) {
        // Se for uma rota interna, navega
        if (this.banner.btn_action.startsWith("/")) {
          this.$router.push(this.banner.btn_action);
        } else if (
          this.banner.btn_action.startsWith("http://") ||
          this.banner.btn_action.startsWith("https://")
        ) {
          // Se for uma URL externa, abre em nova aba
          window.open(this.banner.btn_action, "_blank");
        }
      }

      this.closeBanner();
    },
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 12px;
}

.modal-body {
  padding: 1.5rem;
}

@media (min-width: 576px) {
  .modal-body {
    padding: 2rem;
  }
}

.text-gray-600 {
  color: #6c757d;
}

h3 {
  font-size: 1.25rem;
}

@media (min-width: 576px) {
  h3 {
    font-size: 1.5rem;
  }
}

@media (min-width: 992px) {
  h3 {
    font-size: 1.75rem;
  }
}
</style>

<style>
/* Responsividade do modal */
@media (max-width: 575.98px) {
  #bannerModal .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }
  
  #bannerModal .modal-body img {
    max-height: 300px !important;
  }
}

@media (min-width: 576px) and (max-width: 991.98px) {
  #bannerModal .modal-dialog {
    max-width: 600px;
  }
  
  #bannerModal .modal-body img {
    max-height: 400px !important;
  }
}

@media (min-width: 992px) {
  #bannerModal .modal-dialog {
    max-width: 1140px;
  }
  
  #bannerModal .modal-body img {
    max-height: 500px !important;
  }
}
</style>

